/* Hirsch Hill · Black Friday mode
   Toggle on every page → subscribers go to the landing page, everyone else joins through the popup first.
   Membership is remembered in this browser; signed-in customers who accept marketing count as members. */
(function () {
  'use strict';

  var MEMBER_KEY = 'hh_bf_member';
  var PENDING_KEY = 'hh_bf_pending';
  var root = document.documentElement;

  function store(key, value) {
    try {
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
  }
  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function initMode() {
    var bf = document.querySelector('[data-hh-bf]');
    if (!bf) return;

    var url = bf.getAttribute('data-url') || '/?view=black-friday';
    var onPage = bf.hasAttribute('data-on-page');
    var toggle = bf.querySelector('[data-hh-bf-toggle]');
    var modal = bf.querySelector('[data-hh-bf-modal]');
    var email = modal && modal.querySelector('input[type="email"]');
    var lastFocus = null;

    // Joined: Shopify marks the form as posted, or brings the visitor back with ?customer_posted=true
    // shortly after they submitted the popup (its spam check can drop the form state on the way back).
    var pendingAt = parseInt(read(PENDING_KEY), 10) || 0;
    var recentlySubmitted = pendingAt && Date.now() - pendingAt < 30 * 60 * 1000;
    var postedBack = /[?&]customer_posted=true/.test(window.location.search);
    var hasError = !!bf.querySelector('[data-hh-bf-error]');
    // Shopify may also follow the form's return_to straight to the landing page, with no marker at all:
    // arriving there just after submitting (and without an error) counts as joined too.
    var joined = !hasError && (!!bf.querySelector('[data-hh-bf-joined]') || ((postedBack || onPage) && recentlySubmitted));
    if (hasError) store(PENDING_KEY, null);
    if (joined) store(PENDING_KEY, null);
    if (joined || bf.hasAttribute('data-member')) store(MEMBER_KEY, '1');
    var isMember = function () { return read(MEMBER_KEY) === '1'; };

    function setSwitch(on) {
      if (toggle) toggle.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    function goToLanding() {
      setSwitch(true);
      root.classList.add('hh-bf-leaving');
      setTimeout(function () { window.location.href = url; }, 380);
    }

    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      root.classList.add('hh-bf-modal-open');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      setSwitch(true);
      setTimeout(function () { if (email) email.focus({ preventScroll: true }); }, 250);
    }

    function closeModal() {
      if (!modal || onPage) return;
      modal.classList.remove('is-open');
      root.classList.remove('hh-bf-modal-open');
      setSwitch(false);
      setTimeout(function () { modal.hidden = true; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    // Just joined through the popup (Shopify brings the visitor back with the form marked as posted)
    if (joined) {
      if (onPage) {
        root.classList.remove('hh-bf-locked');
        if (postedBack && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, ''));
        }
      } else {
        goToLanding();
        return;
      }
    }

    if (onPage && !isMember()) {
      root.classList.add('hh-bf-locked');
      openModal();
    } else if (hasError) {
      openModal();
    }

    var form = modal && modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () { store(PENDING_KEY, String(Date.now())); });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (onPage) {
          setSwitch(false);
          root.classList.add('hh-bf-leaving');
          setTimeout(function () { window.location.href = '/'; }, 380);
          return;
        }
        if (isMember()) goToLanding();
        else openModal();
      });
    }

    bf.querySelectorAll('[data-hh-bf-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  /* Countdown: <div data-hh-countdown="2026-11-27T00:00:00+11:00"> with [data-unit="days|hours|minutes|seconds"] */
  function initCountdowns() {
    document.querySelectorAll('[data-hh-countdown]').forEach(function (el) {
      var target = Date.parse(el.getAttribute('data-hh-countdown'));
      if (isNaN(target)) return;
      var units = {};
      el.querySelectorAll('[data-unit]').forEach(function (unit) { units[unit.getAttribute('data-unit')] = unit; });
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var timer;

      function tick() {
        var left = Math.max(0, target - Date.now());
        var s = Math.floor(left / 1000);
        var values = {
          days: Math.floor(s / 86400),
          hours: Math.floor((s % 86400) / 3600),
          minutes: Math.floor((s % 3600) / 60),
          seconds: s % 60
        };
        Object.keys(values).forEach(function (key) {
          if (units[key]) units[key].textContent = key === 'days' ? String(values[key]) : pad(values[key]);
        });
        if (left === 0) {
          clearInterval(timer);
          el.classList.add('is-done');
          // The products are rendered by the server once the launch time passes: reload once to show them.
          if (el.hasAttribute('data-reload-on-launch')) {
            var flag = 'hh_bf_reloaded_' + target;
            try {
              if (!sessionStorage.getItem(flag)) {
                sessionStorage.setItem(flag, '1');
                setTimeout(function () { window.location.reload(); }, 1200);
              }
            } catch (e) {}
          }
        }
      }
      tick();
      timer = setInterval(tick, 1000);
    });

    // Launch date in Melbourne time, e.g. "Friday 27 November, 12:00 am AEDT"
    document.querySelectorAll('[data-hh-launch-text]').forEach(function (el) {
      var date = new Date(el.getAttribute('data-hh-launch-text'));
      if (isNaN(date)) return;
      try {
        var day = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'long', day: 'numeric', month: 'long' }).format(date);
        var time = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(date);
        el.textContent = day.replace(',', '') + ', ' + time;
      } catch (e) {}
    });
  }

  function boot() {
    initMode();
    initCountdowns();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
